import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Environment = 'test' | 'live';

interface EnvState {
    env: Environment;
    setEnv: (env: Environment) => void;
}

export const useEnvStore = create<EnvState>()(
    persist(
        (set) => ({
            env: 'test',
            setEnv: (env) => set({ env }),
        }),
        { name: 'safarapi.console.env' },
    ),
);
